import _ from "lodash";
import React, { Component } from "react";
import { IMAGE_PATH, isTablet } from "Constants";
import { connect } from "react-redux";
import { onExhibitorsinsightMenuSelected } from "ExhibitorinsightActions";
import {
  EXHIBITORSINSIGHT_NOOFEXHI,
  EXHIBITORSINSIGHT_EXHILISTVIEW,
  EXHIBITORSINSIGHT_EXHIPROFVIEW,
  EXHIBITORSINSIGHT_EXHISEARCH,
  EXHIBITORSINSIGHT_EXHIFAVO,
} from "ExhibitorinsightActions";
import AppIcons from "AppIcons";

class ExhibitorinsightMenuIcon extends Component {
  constructor(props) {
    super(props);
  }

  onMenuSelected() {
    this.props.onExhibitorsinsightMenuSelected(this.props.menu);
  }

  render() {
    //var isSelected = `${this.props.selected == true ? 'active' : ''}`;
    var isSelected = `${this.props.selected == true ? "" : ""}`;
    return (
      <li
        className={"dashboardtop-box " + isSelected}
        onClick={this.onMenuSelected.bind(this)}
        style={{
          width: isTablet ? 215 : 258,
          marginLeft: "10px",
          height: "136px",
          cursor: "default",
        }}
      >
        <div className="tabDiv">
          <span className="pull-right iconCircularRight">
            {/* <img
              src={IMAGE_PATH + "/icons/" + this.props.menu.iconName + ".png"}
              className="rounded-circle pull-right"
              alt={this.props.menu.iconName}
            /> */}
            <div className={`icons rounded-circle pull-right`}>
              {AppIcons[this.props.menu.iconName]}
            </div>
          </span>
          <span className="pull-left txtLeft txtLeftSupport">
            <p className="bigNumbers">{this.props.counts}</p>
            <p className="smallTxt">{this.props.menu.sectionName}</p>
          </span>
        </div>
        <div className="analytics-card-lower-div">
          <span>
            <p className="smallTxt2">({this.props.menu.sectionDesc})</p>
          </span>
        </div>
      </li>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var counts = 0;

  switch (ownProps.menu.key) {
    case EXHIBITORSINSIGHT_NOOFEXHI:
      counts = state.exhibitorsinsightTotalNoofexhi
        ? state.exhibitorsinsightTotalNoofexhi.count
        : 0;
      break;
    case EXHIBITORSINSIGHT_EXHILISTVIEW:
      counts = state.exhibitorsinsightTotalExhilistview
        ? state.exhibitorsinsightTotalExhilistview.count
        : 0;
      break;
    case EXHIBITORSINSIGHT_EXHIPROFVIEW:
      counts = state.exhibitorsinsightTotalExhiprofview
        ? state.exhibitorsinsightTotalExhiprofview.count
        : 0;
      break;
    case EXHIBITORSINSIGHT_EXHIFAVO:
      counts = state.exhibitorsinsightTotalExhifavo
        ? state.exhibitorsinsightTotalExhifavo.count
        : 0;
      break;
    case EXHIBITORSINSIGHT_EXHISEARCH:
      counts = state.exhibitorsinsightTotalExhisearch
        ? state.exhibitorsinsightTotalExhisearch.count
        : 0;
      break;
    default:
      counts = 0;
      break;
  }
  return {
    counts,
    exhibitorsinsightSelectedItem: state.exhibitorsinsightSelectedItem,
    selected: ownProps.menu.key === state.exhibitorsinsightSelectedItem,
  };
}

export default connect(mapStateToProps, { onExhibitorsinsightMenuSelected })(
  ExhibitorinsightMenuIcon
);
